import axios, { AxiosResponse } from "axios";
import { UsersUrl } from "./AUrl";
import { RoleResponse } from "./assign_role";

// Function Signatures
type UnassignRoleType = (
    jwt: string,
    userId: number,
    roleName: string,
    scope: string,
    institutionId?: number,
    departmentId?: number,
) => Promise<RoleResponse>;

/*
The function to unassign a role from a user.

@jwt: The JWT of the user making the request.
@userId: The ID of the user losing the role.
@roleName: The name of the role being removed.
@scope: The scope of the role (e.g., institution, department).
@institutionId: The ID of the institution associated with the role.
@departmentId: (Optional) The ID of the department associated with the role.

@returns: The ApiResponse from the unassign role endpoint.
*/
export async function unassignRole(
    jwt: string,
    userId: number,
    roleName: string,
    scope: string,
    institutionId?: number,
    departmentId?: number,
): Promise<RoleResponse> {
    const url = new UsersUrl().unassign_role;
    if (!jwt) {
        return { status: 401, error: "JWT has expired" };
    }

    let response: AxiosResponse<any>;
    try {
        response = await axios.post<RoleResponse | string>(
            url,
            {
                user_id: userId,
                role_name: roleName,
                scope,
                institution_id: institutionId,
                department_id: departmentId,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    token: jwt,
                },
                validateStatus: () => true, // Resolve promise for all HTTP status codes
            },
        );
    } catch (error) {
        return {
            status: 500,
            error: "Network or other error occurred",
        };
    }

    return response.status === 200
        ? { status: response.status, message: response.data as string }
        : { status: response.status, error: response.data as string };
}
